import React from "react";
import { Instagram, Youtube, Map, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Separator } from "@/components/ui/separator";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-2">
        {[1, 2, 3, 4].map(i => <div key={i} className="h-4 w-24 bg-muted/20 animate-pulse rounded-sm" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return null;
  }
  return <ul className="space-y-2">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors text-sm flex items-center gap-2 group">
            <ArrowRight className="w-3 h-3 opacity-0 -ml-5 group-hover:opacity-100 group-hover:ml-0 transition-all duration-300 text-chart-2" />
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function ExpeditionFooter() {
  return <footer id="expedition-footer" className="dark bg-background text-foreground border-t-4 border-chart-2 relative overflow-hidden pt-16 pb-8">
      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1562326/img/topo_map_texture.png)] bg-cover bg-center opacity-5 pointer-events-none mix-blend-overlay" />

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          
          {}
          <div className="space-y-6">
            <Link to="/" className="block">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1562326/img/wildlings_west_logo.png" alt="Wildlings West Overland" className="h-7 w-auto object-contain" />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed">
              Wildlings West Overland is an adventure‑travel content hub dedicated to family overlanding across the American West. We provide expert guides, vehicle builds, and authentic gear reviews for the modern explorer.
            </p>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="text-sm font-bold tracking-widest uppercase text-foreground">
              Quick Links
            </h3>
            <MenuProvider menu_id="35">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="text-sm font-bold tracking-widest uppercase text-foreground">
              Follow Us
            </h3>
            <div className="flex flex-col gap-4">
              <Link to="https://instagram.com" newTab className="flex items-center gap-3 text-muted-foreground hover:text-[#E1306C] transition-colors group">
                <div className="p-2 rounded-full bg-secondary group-hover:bg-[#E1306C]/10 transition-colors">
                  <Instagram className="w-5 h-5" />
                </div>
                <span className="text-sm font-medium">Instagram</span>
              </Link>
              
              <Link to="https://youtube.com" newTab className="flex items-center gap-3 text-muted-foreground hover:text-[#FF0000] transition-colors group">
                <div className="p-2 rounded-full bg-secondary group-hover:bg-[#FF0000]/10 transition-colors">
                  <Youtube className="w-5 h-5" />
                </div>
                <span className="text-sm font-medium">YouTube</span>
              </Link>

              <Link to="https://trailforks.com" newTab className="flex items-center gap-3 text-muted-foreground hover:text-[#FFCD00] transition-colors group">
                <div className="p-2 rounded-full bg-secondary group-hover:bg-[#FFCD00]/10 transition-colors">
                  <Map className="w-5 h-5" />
                </div>
                <span className="text-sm font-medium">Trailforks</span>
              </Link>
            </div>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="text-sm font-bold tracking-widest uppercase text-foreground">
              Disclosure
            </h3>
            <div className="p-4 rounded bg-secondary/30 border border-border/50">
              <p className="text-[10px] font-mono text-muted-foreground leading-relaxed">
                Wildlings West Overland is a participant in various affiliate marketing programs. We may receive a commission on purchases made through our links to retailer sites. This supports our mission to keep our content free and authentic.
              </p>
            </div>
          </div>
        </div>

        <Separator className="bg-border/50 mb-8" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-muted-foreground font-mono">
          <p>&copy; {new Date().getFullYear()} Wildlings West Overland. All rights reserved.</p>
          <div className="flex gap-6">
            <Link to="/privacy-policy" className="hover:text-primary transition-colors">Privacy Policy</Link>
            <Link to="/terms-of-service" className="hover:text-primary transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>;
}